import { __rest } from 'tslib';
import React from 'react';

const createContext = (provider, initial) => {
    const Context = React.createContext(initial);
    const Provider = (props) => {
        const { children } = props, context = __rest(props, ["children"]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = React.useMemo(() => context, Object.values(context));
        return React.createElement(Context.Provider, { value: value }, children);
    };
    const useContext = (consumer) => {
        const context = React.useContext(Context);
        if (context)
            return context;
        if (initial !== undefined)
            return initial;
        throw new Error(`\`${consumer}\` must be used within \`${provider}\``);
    };
    Provider.displayName = `${provider}Provider`;
    return [Provider, useContext];
};

export { createContext };
//# sourceMappingURL=createContext.js.map
